(function documentTypeAssociateMetadataControllerDefinition() {
    'use strict';

    angular.module('DocumentContainer')
        .controller('DocumentContainerAssociateController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', '$uibModal', 'errorsExtend', 'documentContainerService', 'authExtend',
    function documentCointanierAssociateController($scope, config, $state, $translate, $stateParams, $modal, errors, documentContainerService, authExtend) {
        $scope.docContainersPlaceHolder = 'DocumentDocumentContainerPlaceholder';

        $scope.model = {
            documents: documentContainerService.getDocuments(),
            container: null
        };

        documentContainerService.clearDocuments();

        $scope.cancel = function () {
            $state.go(documentContainerService.getState());
        };

        $scope.removeDocument = function (docu) {

            var index = -1;

            for (var i in $scope.model.documents) {
                if ($scope.model.documents.hasOwnProperty(i)) {
                    if ($scope.model.documents[i].id === docu.id) {
                        index = i;
                        break;
                    }
                }
            };

            if (~index) {
                $scope.model.documents.splice(index, 1);
            }
        };

        $scope.save = function () {

            var msj = '';

            if (!$scope.documentContainerForm.$valid || !$scope.model.container.id) {
                $scope.documentContainerForm.$setSubmitted();
                msj = 'VerifyFormData';
            }

            if ($scope.model.documents.length <= 0) {
                msj += 'VerifyFormNoDocuments';
            }

            if (msj !== '') {
                errors.showError(msj);
                return;
            }

            $scope.model.container.documents = $scope.model.documents;

            return documentContainerService.associate($scope.model.container)
                .then(function () {
                    $scope.cancel();
                }, function (error) {
                    errors.showError(error);
                });
        };

    }]);
})();